import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'zip_code_protection-retailer_exclusivity_product_details_page_policy-action_category_click';

/**
 * Triggered when user click the View Details button on the product details page exclusivity policy
 */
export function trackZipCodeProtectionRetailerExclusivityProductDetailsPagePolicyActionCategoryClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
